<div class="main-content commission-report-page">
	<div class="container-fluid">
		<div class="row">
			<div class="col-12">
				<div class="card commission-report-card">
					<div class="card-header card-header-{{color}}-6">
						<h4 class="card-title">
							<i class="material-icons commission-report-back" (click)="back()">arrow_back</i>
							Commissioned Sales Report
						</h4>
						<p class="card-category text-right mb-0">Earned commission on invoiced lines</p>
					</div>
					<div class="card-body">
						<section class="commission-filters" aria-label="Report filters">
							<div class="commission-filters__head">
								<span class="commission-filters__title">Filters</span>
								<span class="commission-filters__hint">Set criteria, then run the report</span>
							</div>
							<form (ngSubmit)="$event.preventDefault(); runReport()">
								<div class="row g-3">
									<div class="col-md-4">
										<mat-form-field appearance="outline" class="w-100 commission-field">
											<mat-label>Transaction dates</mat-label>
											<mat-date-range-input [rangePicker]="picker">
												<input matStartDate [formControl]="fromdateCtrl" placeholder="Start" />
												<input matEndDate [formControl]="todateCtrl" placeholder="End" />
											</mat-date-range-input>
											<mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
											<mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
											<mat-date-range-picker #picker></mat-date-range-picker>
										</mat-form-field>
									</div>
									<div class="col-md-4">
										<mat-form-field appearance="outline" class="w-100 commission-field">
											<mat-label>Product line</mat-label>
											<mat-select [formControl]="productLineRef">
												<mat-option value="">All product lines</mat-option>
												<mat-option *ngFor="let pl of productLines" [value]="pl.lineid">
													{{ pl.linedescription }}
												</mat-option>
											</mat-select>
										</mat-form-field>
									</div>
									<div class="col-md-4">
										<mat-form-field appearance="outline" class="w-100 commission-field">
											<mat-label>Salesperson</mat-label>
											<mat-select [formControl]="salespersonRef">
												<mat-option value="">All salespeople</mat-option>
												<mat-option *ngFor="let sp of salespeople" [value]="sp.salesmancode">
													{{ sp.salesmancode }} — {{ sp.salesmanname }}
												</mat-option>
											</mat-select>
										</mat-form-field>
									</div>
									<div class="col-md-4">
										<mat-form-field appearance="outline" class="w-100 commission-field">
											<mat-label>Vendor</mat-label>
											<mat-select [formControl]="supplierRef">
												<mat-option value="">All vendors</mat-option>
												<mat-option *ngFor="let s of suppliers" [value]="s.supplierid">
													{{ s.suppname }}
												</mat-option>
											</mat-select>
										</mat-form-field>
									</div>
									<div class="col-md-4">
										<mat-form-field appearance="outline" class="w-100 commission-field">
											<mat-label>Location</mat-label>
											<mat-select [formControl]="locationRef">
												<mat-option value="">All locations</mat-option>
												<mat-option *ngFor="let l of locations" [value]="l.loccode">
													{{ l.locationname }}
												</mat-option>
											</mat-select>
										</mat-form-field>
									</div>
									<div class="col-md-4">
										<mat-form-field appearance="outline" class="w-100 commission-field">
											<mat-label>Stock category</mat-label>
											<mat-select [formControl]="categoryRef">
												<mat-option value="">All categories</mat-option>
												<mat-option *ngFor="let c of categories" [value]="c.categoryid">
													{{ c.name }}
												</mat-option>
											</mat-select>
										</mat-form-field>
									</div>
									<div class="col-md-4">
										<mat-form-field appearance="outline" class="w-100 commission-field">
											<mat-label>Item keywords</mat-label>
											<input matInput [formControl]="keywordsRef" placeholder="Description or stock ID" />
										</mat-form-field>
									</div>
									<div class="col-md-4">
										<mat-form-field appearance="outline" class="w-100 commission-field">
											<mat-label>Customer</mat-label>
											<input matInput [formControl]="customerInfoRef" placeholder="Customer # or name" />
										</mat-form-field>
									</div>
									<div class="col-md-4 d-flex align-items-center commission-checkbox-wrap">
										<mat-checkbox [formControl]="groupByCustomerRef" color="primary">
											Group by customer + stock
										</mat-checkbox>
									</div>
								</div>
								<div class="commission-actions">
									<button mat-raised-button color="accent" type="submit" class="commission-actions__primary">
										<mat-icon>search</mat-icon>
										Run report
									</button>
									<span *ngIf="sending" class="commission-actions__spinner">
										<mat-spinner diameter="36"></mat-spinner>
									</span>
									<div class="commission-actions__exports" *ngIf="dataSource.data.length">
										<button
											mat-stroked-button
											type="button"
											class="commission-export commission-export--xls"
											(click)="$event.preventDefault(); exportXls()"
										>
											<mat-icon>table_chart</mat-icon>
											Excel
										</button>
										<button
											mat-stroked-button
											type="button"
											class="commission-export commission-export--pdf"
											(click)="$event.preventDefault(); exportPdf()"
										>
											<mat-icon>picture_as_pdf</mat-icon>
											PDF
										</button>
									</div>
								</div>
							</form>
						</section>

						<section class="commission-results" *ngIf="reportCriteria && totals">
							<div class="commission-results__heading">
								<h3 class="commission-results__title">
									Commissioned Sales
									<span class="commission-results__dates">
										{{ reportCriteria.datefrom | date : 'MM/dd/yy' }} – {{ reportCriteria.dateto | date : 'MM/dd/yy' }}
									</span>
								</h3>
								<p class="commission-results__subtitle" *ngIf="getReportSubtitle()">{{ getReportSubtitle() }}</p>
							</div>

							<div class="commission-kpi-grid" role="group" aria-label="Report totals">
								<div class="commission-kpi">
									<span class="commission-kpi__label">Customers</span>
									<span class="commission-kpi__value">{{ totals.distinctCustomers | number : '1.0-0' }}</span>
								</div>
								<div class="commission-kpi">
									<span class="commission-kpi__label">Quantity</span>
									<span class="commission-kpi__value">{{ totals.qty | number : '1.0-2' }}</span>
								</div>
								<div class="commission-kpi">
									<span class="commission-kpi__label">Sales</span>
									<span class="commission-kpi__value commission-kpi__value--money">{{ totals.lineSales | currency }}</span>
								</div>
								<div class="commission-kpi">
									<span class="commission-kpi__label">Cost</span>
									<span class="commission-kpi__value commission-kpi__value--money">{{ totals.lineCost | currency }}</span>
								</div>
								<div class="commission-kpi">
									<span class="commission-kpi__label">Gross profit</span>
									<span class="commission-kpi__value commission-kpi__value--money commission-kpi__value--gp">{{ totals.gp | currency }}</span>
								</div>
								<div class="commission-kpi commission-kpi--featured">
									<span class="commission-kpi__label">Commission</span>
									<span class="commission-kpi__value commission-kpi__value--money">{{ totals.commission | currency }}</span>
								</div>
							</div>
						</section>

						<div class="commission-table-panel" *ngIf="dataSource.data.length">
							<div class="commission-table-panel__bar">
								<span class="commission-table-panel__label">Line detail</span>
								<span class="commission-table-panel__meta" *ngIf="dataSource.data.length">{{ dataSource.data.length | number }} rows</span>
							</div>
							<div class="commission-table-wrap">
								<table mat-table matSort [dataSource]="dataSource" class="mat-elevation-z0 w-100 commission-table">
									<ng-container matColumnDef="trandate">
										<th mat-header-cell *matHeaderCellDef mat-sort-header>Date</th>
										<td mat-cell *matCellDef="let r">{{ r.trandate | date : 'MM/dd/yyyy' }}</td>
									</ng-container>
									<ng-container matColumnDef="documentLabel">
										<th mat-header-cell *matHeaderCellDef mat-sort-header>Document</th>
										<td mat-cell *matCellDef="let r" class="doc-cell">
											<ng-container *ngIf="documentParts(r.documentLabel) as doc">
												<span class="doc-cell__no">{{ doc.main }}</span>
												<span class="doc-cell__type" *ngIf="doc.sub">{{ doc.sub }}</span>
											</ng-container>
										</td>
									</ng-container>
									<ng-container matColumnDef="customerId">
										<th mat-header-cell *matHeaderCellDef mat-sort-header>Cust #</th>
										<td mat-cell *matCellDef="let r" class="text-nowrap">{{ r.customerId }}</td>
									</ng-container>
									<ng-container matColumnDef="customerName">
										<th mat-header-cell *matHeaderCellDef mat-sort-header>Customer</th>
										<td mat-cell *matCellDef="let r" class="desc-cell" [matTooltip]="r.customerName">{{ r.customerName }}</td>
									</ng-container>
									<ng-container matColumnDef="description">
										<th mat-header-cell *matHeaderCellDef mat-sort-header>Description</th>
										<td mat-cell *matCellDef="let r" class="desc-cell" [matTooltip]="r.description">{{ r.description }}</td>
									</ng-container>
									<ng-container matColumnDef="lineId">
										<th mat-header-cell *matHeaderCellDef mat-sort-header>Line</th>
										<td mat-cell *matCellDef="let r">{{ r.lineId }}</td>
									</ng-container>
									<ng-container matColumnDef="lineDescription">
										<th mat-header-cell *matHeaderCellDef mat-sort-header>Line desc</th>
										<td mat-cell *matCellDef="let r" class="desc-cell">{{ r.lineDescription }}</td>
									</ng-container>
									<ng-container matColumnDef="categoryName">
										<th mat-header-cell *matHeaderCellDef mat-sort-header>Category</th>
										<td mat-cell *matCellDef="let r">{{ r.categoryName }}</td>
									</ng-container>
									<ng-container matColumnDef="mfgPart">
										<th mat-header-cell *matHeaderCellDef mat-sort-header>MFG #</th>
										<td mat-cell *matCellDef="let r" class="text-nowrap">{{ r.mfgPart }}</td>
									</ng-container>
									<ng-container matColumnDef="stockId">
										<th mat-header-cell *matHeaderCellDef mat-sort-header>Stock ID</th>
										<td mat-cell *matCellDef="let r" class="text-nowrap">{{ r.stockId }}</td>
									</ng-container>
									<ng-container matColumnDef="typeName">
										<th mat-header-cell *matHeaderCellDef mat-sort-header>Type</th>
										<td mat-cell *matCellDef="let r">{{ r.typeName }}</td>
									</ng-container>
									<ng-container matColumnDef="unitPriceAfterDiscount">
										<th mat-header-cell *matHeaderCellDef mat-sort-header class="text-end">Unit</th>
										<td mat-cell *matCellDef="let r" class="text-end">{{ r.unitPriceAfterDiscount | currency }}</td>
									</ng-container>
									<ng-container matColumnDef="qty">
										<th mat-header-cell *matHeaderCellDef mat-sort-header class="text-end">Qty</th>
										<td mat-cell *matCellDef="let r" class="text-end">{{ r.qty | number : '1.0-4' }}</td>
									</ng-container>
									<ng-container matColumnDef="standardUnitCost">
										<th mat-header-cell *matHeaderCellDef mat-sort-header class="text-end">Std cost</th>
										<td mat-cell *matCellDef="let r" class="text-end">{{ r.standardUnitCost | currency }}</td>
									</ng-container>
									<ng-container matColumnDef="lineSales">
										<th mat-header-cell *matHeaderCellDef mat-sort-header class="text-end">Sales</th>
										<td mat-cell *matCellDef="let r" class="text-end">{{ r.lineSales | currency }}</td>
									</ng-container>
									<ng-container matColumnDef="lineCost">
										<th mat-header-cell *matHeaderCellDef mat-sort-header class="text-end">Line cost</th>
										<td mat-cell *matCellDef="let r" class="text-end">{{ r.lineCost | currency }}</td>
									</ng-container>
									<ng-container matColumnDef="gp">
										<th mat-header-cell *matHeaderCellDef mat-sort-header class="text-end">GP</th>
										<td mat-cell *matCellDef="let r" class="text-end">{{ r.gp | currency }}</td>
									</ng-container>
									<ng-container matColumnDef="gpPctDisplay">
										<th mat-header-cell *matHeaderCellDef mat-sort-header class="text-end">GP %</th>
										<td mat-cell *matCellDef="let r" class="text-end">{{ r.gpPctDisplay | number : '1.2-2' }}</td>
									</ng-container>
									<ng-container matColumnDef="commissionPct">
										<th mat-header-cell *matHeaderCellDef mat-sort-header class="text-end">Comm %</th>
										<td mat-cell *matCellDef="let r" class="text-end">{{ r.commissionPct | number : '1.1-1' }}</td>
									</ng-container>
									<ng-container matColumnDef="commissionAmount">
										<th mat-header-cell *matHeaderCellDef mat-sort-header class="text-end">Commission</th>
										<td mat-cell *matCellDef="let r" class="text-end commission-amt-cell">{{ r.commissionAmount | currency }}</td>
									</ng-container>
									<ng-container matColumnDef="salespersonName">
										<th mat-header-cell *matHeaderCellDef mat-sort-header>Salesperson</th>
										<td mat-cell *matCellDef="let r">{{ r.salespersonName }}</td>
									</ng-container>
									<tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
									<tr mat-row *matRowDef="let row; columns: displayedColumns" class="commission-data-row"></tr>
								</table>
							</div>
						</div>

						<div
							*ngIf="metaLoaded && !sending && reportCriteria && !dataSource.data.length"
							class="commission-empty"
						>
							<mat-icon>search_off</mat-icon>
							<p>No lines matched the selected criteria.</p>
							<span class="commission-empty__hint">Try widening the date range or clearing filters.</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
